import {
  BrandingKey,
  BuilderKey,
  ControlKey,
  GuardKey,
  MicrositePageKey,
  PreviewKey,
  PublishKey,
  TabsKey
} from '../../TModules';
import { MicrositeTranslations } from '../en/translations';

export const translations: MicrositeTranslations = {
  [MicrositePageKey]: {
    OtherSettings: 'Altre impostazioni',
    SettingUpdated: 'Impostazione aggiornata',
    FailedToUpdateSetting: "Impossibile aggiornare l'impostazione",
    Loading: 'Caricamento',
    LoadError: 'Impossibile caricare le impostazioni',
    AllowCustomNickname: 'Consenti agli utenti di impostare un soprannome personalizzato',
    AllowCustomNicknameSubtext:
      'Quando abilitato, gli utenti del microsito possono impostare un soprannome univoco nel loro profilo che verrà utilizzato come ID alternativo.'
  },
  [TabsKey]: {
    Details: 'Dettagli',
    Branding: 'Branding',
    Microsite: 'Microsite',
    ControlSettings: 'Impostazioni di controllo'
  },
  [BrandingKey]: {
    Cards: {
      BrandIdentity: 'Identità del brand',
      Typography: 'Tipografia',
      BackgroundColors: 'Colori di sfondo',
      TextColors: 'Colori del testo',
      SemanticColors: 'Colori semantici',
      AccentColors: 'Colori di accento',
      Others: 'Altro',
      Buttons: 'Pulsanti'
    },
    Tooltips: {
      BrandIdentity:
        'Configura l’identità del brand usata in tutta l’esperienza, inclusi nome dell’applicazione, colori del brand, logo e raggio del bordo globale.',
      Typography:
        'Definisci la famiglia di caratteri usata in tutta l’esperienza per una tipografia coerente e leggibile.',
      BackgroundColors:
        'Configura i colori di sfondo delle aree principali dell’esperienza, incluse sezioni, intestazione dell’app, sfondo dell’app e aree hero.',
      TextColors:
        'Definisci i colori di titoli, corpo del testo, testo di supporto e link per uno stile del testo coerente e leggibile.',
      SemanticColors:
        'Definisci i colori standard usati per comunicare significato e stato, come successo, avviso, errore, informazione, neutro e promozionale.',
      AccentColors:
        'Configura colori di supporto aggiuntivi usati per evidenziazioni, elementi visivi e componenti dell’interfaccia in tutta l’esperienza.',
      Others:
        'Configura colori aggiuntivi per elementi dell’interfaccia come icone primarie e secondarie.',
      Buttons:
        'Configura l’aspetto dei pulsanti primari e secondari, inclusi riempimento, testo, bordo, stati disattivati, altezza e raggio del bordo.'
    },
    Fields: {
      title: 'Nome dell’applicazione',
      primary_color: 'Colore primario del brand',
      secondary_color: 'Colore secondario del brand',
      logo: 'Immagine del logo',
      border_radius: 'Raggio del bordo globale',
      font: 'Famiglia di caratteri',
      bg_primary_color: 'Primario',
      bg_secondary_color: 'Secondario',
      bg_tertiary_color: 'Terziario',
      bg_alternative_color: 'Alternativo',
      header_color: 'Intestazione app',
      app_bg_color: 'Sfondo app',
      font_color: 'Primario',
      text_secondary_color: 'Secondario',
      text_tertiary_color: 'Terziario',
      link_color: 'Link',
      success_color: 'Successo',
      warning_color: 'Avviso',
      error_color: 'Errore',
      information_color: 'Informazione',
      neutral_color: 'Neutro',
      promotional_color: 'Promozionale',
      accent_color: 'Accento 1',
      accent_2_color: 'Accento 2',
      accent_3_color: 'Accento 3',
      accent_4_color: 'Accento 4',
      accent_5_color: 'Accento 5',
      accent_6_color: 'Accento 6',
      icon_primary_color: 'Icona primaria',
      icon_secondary_color: 'Icona secondaria',
      CTA_button_bg_color: 'Riempimento',
      CTA_button_text_color: 'Colore del testo',
      CTA_button_disabled_bg_color: 'Riempimento disattivato',
      CTA_button_disabled_text_color: 'Testo disattivato',
      secondary_button_bg_color: 'Riempimento',
      secondary_button_border_color: 'Bordo',
      secondary_button_text_color: 'Colore del testo',
      secondary_button_disabled_bg_color: 'Riempimento disattivato',
      secondary_button_disabled_border_color: 'Bordo disattivato',
      secondary_button_disabled_text_color: 'Testo disattivato',
      button_height: 'Altezza pulsante (px)',
      button_border_radius: 'Raggio del bordo (px)'
    },
    Help: {
      PrimaryColor:
        'Il colore primario è usato ad esempio per le evidenziazioni delle barre di avanzamento',
      Logo: 'PNG o SVG, consigliato 120 × 30 px',
      BorderRadius: 'Applicato globalmente a schede, campi di input e badge.'
    },
    Radius: {
      Small: 'Piccolo - 4px',
      Medium: 'Medio - 8px',
      Large: 'Grande - 16px',
      Sharp: 'Squadrato - 0px'
    },
    Px: 'px',
    Replace: 'Sostituisci',
    TooltipLabel: 'Informazioni su {{section}}',
    ResetToDefault: 'Ripristina predefiniti',
    Reset: 'Reimposta',
    Save: 'Salva modifiche',
    Sample: 'Esempio',
    SampleText: 'Quel vituperabile xenofobo zelante assaggia il whisky',
    UnsupportedFont: '{{font}} (non supportato)',
    Preview: 'Anteprima',
    PreviewHeading: 'Testo del titolo',
    PreviewBody: 'Esempio di corpo del testo',
    PreviewCaption: 'Didascalia o testo di aiuto',
    PreviewLink: 'Testo del link',
    PrimaryButton: 'Pulsante primario',
    SecondaryButton: 'Pulsante secondario',
    SharedSizing: 'Dimensioni condivise',
    ButtonPrimary: 'Primario',
    ButtonSecondary: 'Secondario',
    ButtonSmall: 'Piccolo',
    ButtonDisabled: 'Disattivato',
    Errors: {
      Required: 'Questo campo è obbligatorio',
      invalid_hex: 'Inserisci un colore HEX valido, ad es. #0284C7',
      logo_required: "L'immagine del logo è obbligatoria",
      unsupported_font: 'Questo carattere non è più supportato. Scegli un altro carattere.',
      invalid_integer: 'Inserisci un numero intero pari o superiore a 0'
    },
    Toasts: {
      Saved: 'Branding salvato',
      SaveFailed: 'Impossibile salvare il branding. Riprova.',
      FixErrors: 'Correggi i campi evidenziati prima di salvare.'
    },
    Load: {
      Failed: 'Impossibile caricare le impostazioni di branding.',
      Retry: 'Riprova'
    }
  },
  [BuilderKey]: {
    StartingPoint: {
      Title: 'Crea il tuo Microsite',
      Subtitle: 'Seleziona come avviare il tuo portale di esperienza cliente.',
      TemplateTitle: 'Inizia con un modello',
      TemplateDescription:
        'Scegli tra profili di layout predefiniti pensati per meccaniche fedeltà e punti.',
      BlankTitle: 'Inizia con una pagina vuota',
      BlankDescription:
        'Parti da un’area di lavoro vuota e trascina manualmente i componenti nel builder.',
      Continue: 'Continua',
      ReadOnly: 'Hai accesso in sola lettura, quindi non puoi creare il microsite.'
    },
    Existing: {
      Title: 'Il tuo microsite salvato',
      Published: 'Pubblicato: {{name}}',
      PublishedAt: 'Pubblicato il {{date}}',
      Draft: 'Bozza: {{name}}',
      DraftUpdatedAt: 'Ultimo salvataggio il {{date}}',
      Label: '{{template}} · {{theme}}',
      BlankCanvas: 'Tela vuota',
      BrandingTheme: 'Tema del branding globale',
      TemplateTheme: 'Tema predefinito del modello',
      View: 'Visualizza',
      OverwriteDraft: 'Sovrascrivi il modello bozza',
      OverwritePublished: 'Sovrascrivi il modello pubblicato',
      Duplicate: {
        Title: 'Il modello esiste già',
        Published:
          'Questo modello è già pubblicato. Per apportare modifiche, fai clic su Visualizza, modifica il modello esistente e pubblicalo di nuovo.',
        Draft:
          'Questo modello esiste già come bozza. Per apportare modifiche, fai clic su Visualizza e modifica la bozza esistente.',
        Close: 'OK'
      },
      Confirm: {
        Title: 'Sostituire la pagina salvata?',
        Published:
          'Hai già un modello pubblicato ({{current}}). Iniziare con {{next}} sostituirà la bozza salvata al salvataggio e la pagina live alla pubblicazione. Continuare?',
        Draft:
          'Hai già una bozza salvata ({{current}}). Iniziare con {{next}} sostituirà la bozza salvata al salvataggio. Continuare?',
        Continue: 'Continua',
        Cancel: 'Annulla'
      }
    },
    Templates: {
      Title: 'Scegli un modello di tema',
      Subtitle: 'Seleziona un modello preintegrato per definire la tua esperienza di premi.',
      Back: 'Indietro',
      Empty: 'Nessun modello disponibile.',
      UseSelected: 'Usa il modello selezionato',
      Descriptions: {
        point_utilization:
          'Meccanismi di utilizzo immediato dei punti e visualizzazione del catalogo.',
        hybrid_driven: 'Punti, sfide e statistiche del brand in equilibrio.',
        progress_driven: 'Traguardi gamificati, livelli e metriche dei punti.',
        reward_driven: 'Premi di tendenza e offerte vicine basate sulla posizione.'
      }
    },
    ThemeSource: {
      Title: 'Seleziona la fonte del tema',
      Description: 'Scegli da dove provengono i colori e la tipografia di questo modello.',
      TemplateDefault: 'Usa le impostazioni del tema predefinito del modello',
      TemplateDefaultHelp:
        'Applica i colori e la tipografia predefiniti del modello a tutte le sezioni.',
      Branding: 'Usa le impostazioni del branding globale',
      BrandingHelp:
        'Applica gli ultimi colori e la tipografia di branding salvati a tutte le sezioni.',
      BrandingBlocked:
        'Il branding globale è incompleto o non valido. Completalo e salvalo prima nella scheda Branding.',
      GoToBranding: 'Vai al branding',
      Confirm: 'Applica',
      Cancel: 'Annulla'
    },
    Editor: {
      PageStructure: 'Struttura della pagina',
      Sections: 'Sezioni',
      ReorderHint: 'Trascina le sezioni per riordinarle',
      AddSection: 'Aggiungi sezione',
      AddSectionHint: 'Trascina le sezioni nell’area di lavoro o fai clic per aggiungerle',
      Settings: 'Impostazioni {{name}}',
      Layout: 'Layout',
      LayoutUnavailable: 'Non sono ancora disponibili layout per questa sezione.',
      SelectSection: 'Seleziona una sezione da configurare.',
      Card: 'Carta {{number}}',
      NearbyReward: {
        RewardDistance: 'Distanza della ricompensa'
      },
      CategoryReward: {
        RewardsCategoryFilter: 'Filtro categorie di ricompense',
        RewardsCategoryFilterTooltip:
          'Mostra tutte le categorie configurate per filtrare le ricompense.'
      },
      PointRedemption: {
        DisplayImage: 'Immagine visualizzata',
        DisplayImageHint: '{{size}}px per {{size}}px consigliati',
        TitleText: 'Testo del titolo',
        SubtitleText: 'Testo del sottotitolo',
        SemanticText: 'Testo semantico',
        PointsText: 'Testo dei punti'
      },
      TransferPoints: {
        DisplayImage: 'Immagine visualizzata',
        DisplayImageHint: '{{size}}px per {{size}}px consigliati',
        BackgroundNumber: 'Sfondo {{number}}',
        TitleText: 'Testo del titolo',
        SubtitleText: 'Testo del sottotitolo'
      },
      AvailableChallenges: {
        CampaignTitle: 'Titolo della campagna',
        ChallengeTypeFilter: 'Filtro dei tipi di sfide',
        ChallengeTypeFilterTooltip:
          'Mostra tutti i tipi di sfide per filtrare le sfide disponibili.'
      },
      GamesAndChallenges: {
        AppearanceTooltips: {
          Accent1: 'Sfondo del badge Nuovo',
          Accent2: 'Sfondo del badge In arrivo',
          Accent3: 'Sfondo del badge della data di fine',
          Semantic1: 'Testo del badge Nuovo',
          Semantic2: 'Testo del badge In arrivo',
          Semantic3: 'Testo del badge della data di fine'
        },
        CardBackground: 'Sfondo della scheda',
        ChallengeTitle: 'Titolo della sfida',
        DescriptionText: 'Testo della descrizione',
        AccentNumber: 'Accento {{number}}',
        SemanticNumber: 'Semantica {{number}}',
        Description: 'Descrizione',
        NewBadge: 'Badge Novità',
        UpcomingBadge: 'Badge In arrivo',
        EndDateBadge: 'Badge data di fine',
        CarouselContentTooltip:
          'Scegli quante sfide mostrare nel carosello. Lascia vuoto per mostrare tutte le sfide con scorrimento infinito.',
        ChallengesToDisplay: 'Sfide da mostrare',
        SeeAllHint: 'Porta gli utenti alla pagina delle sfide per visualizzare tutte le sfide.'
      },
      FeaturedReward: {
        AccentTooltip: 'Sfondo del badge',
        SemanticTooltip: 'Testo del badge',
        Visibility: 'Visibilità',
        PointsBadge: 'Badge punti',
        RewardTitle: 'Titolo della ricompensa',
        MerchantName: 'Nome del commerciante',
        SellingDate: 'Data di vendita',
        CarouselContent: 'Contenuto del carosello',
        CarouselContentTooltip:
          'Scegli quante ricompense mostrare nel carosello. Lascia vuoto per mostrare tutte le ricompense con scorrimento infinito.',
        RewardsToDisplay: 'Ricompense da mostrare',
        ShowSeeAll: 'Mostra il pulsante «Vedi tutto»',
        SeeAllHint:
          'Porta gli utenti alla pagina dell’elenco delle ricompense per visualizzarle tutte.'
      },
      SectionSettings: {
        Title: 'Impostazioni della sezione',
        ShowTitle: 'Mostra titolo',
        TitleText: 'Testo del titolo',
        TranslateTitle: 'Traduci il titolo',
        Translation: 'Traduzione',
        BackToSettings: 'Torna alle impostazioni',
        TranslationLanguages: {
          en: 'Inglese',
          ar: 'Arabo',
          fr: 'Francese',
          id: 'Indonesiano',
          it: 'Italiano',
          vi: 'Vietnamita'
        },
        TextColor: 'Colore del testo',
        SectionBackground: 'Sfondo della sezione',
        BackgroundColor: 'Colore di sfondo',
        Margin: 'Margine',
        Top: 'Superiore',
        Bottom: 'Inferiore'
      },
      Appearance: {
        Title: 'Aspetto',
        ResetToTemplate: 'Ripristina il modello',
        ResetToBranding: 'Ripristina il branding',
        Background: 'Sfondo',
        CardBackground: 'Sfondo della carta',
        CardBackground1: 'Sfondo della carta 1',
        CardBackground2: 'Sfondo della carta 2',
        RankBackground: 'Sfondo della posizione',
        Alternate: 'Alternativo',
        TextNumber: 'Testo {{number}}',
        ActiveStreakTextTooltips: {
          Text1: 'Conteggio della serie',
          Text2: 'Attività della serie',
          Text3: 'Descrizione'
        },
        LeaderboardTextTooltips: {
          Text1: 'Posizione',
          Text2: 'Etichetta',
          Text3: 'Titolo della classifica'
        },
        Text: 'Testo',
        TextColor: 'Testo',
        ExpiryTextColor: 'Semantica',
        Accent: 'Accento',
        Semantic: 'Semantica',
        Icon: 'Icona',
        ButtonType: 'Tipo di pulsante',
        PrimaryButton: 'Pulsante primario',
        SecondaryButton: 'Pulsante secondario'
      }
    },
    Panel: {
      Title: 'Sezioni',
      Add: 'Aggiungi sezione',
      Empty: 'Nessuna sezione aggiunta.',
      MoveUp: 'Sposta {{name}} in alto',
      MoveDown: 'Sposta {{name}} in basso',
      Remove: 'Rimuovi {{name}}',
      LayoutLabel: 'Layout di {{name}}',
      Layouts: {
        Carousel: 'Carosello',
        List: 'Elenco',
        Grid: 'Griglia'
      },
      QuickLinksLabel: 'Link rapidi',
      QuickLinksPlaceholder: 'Seleziona i link rapidi',
      QuickActionLabel: 'Azione {{number}}',
      QuickActionPlaceholder: 'Seleziona un link rapido',
      QuickActionUpload: 'Carica',
      QuickActionUploaded: 'Caricata',
      QuickActionUploadLabel: 'Carica immagine per l’azione {{number}}',
      QuickActionImageHint: '48 px per 48 px consigliati',
      QuickActionImageTooLarge: 'Le immagini non devono superare {{size}} KB',
      QuickActionImageType: 'Carica un’immagine PNG, JPEG o WebP',
      QuickActionsReset: 'Ripristina il modello',
      TagLabel: 'Tag',
      TagPlaceholder: 'Seleziona un tag',
      TagsLabel: 'Tag',
      TagsInfo: 'Mostra tutti i tag configurati',
      TagsEmpty: 'Nessun tag configurato.',
      TagUnavailable: 'Il tag selezionato non è più disponibile. Seleziona un altro tag.',
      CategoryFilter: 'Filtro categoria',
      CampaignTypeFilter: 'Filtro tipo di campagna',
      SectionIssue: 'Questa sezione deve essere corretta prima della pubblicazione.'
    },
    Canvas: {
      Label: 'Canvas della landing page',
      Empty: 'Nessuna sezione. Aggiungi sezioni per iniziare a costruire la tua landing page.',
      SelectTag: 'Seleziona un tag per visualizzare l’anteprima di questa sezione.',
      NoItems: 'Nessun elemento da mostrare in questa sezione.',
      LoadFailed: 'Impossibile caricare gli elementi di anteprima.',
      StaticSection: 'Mostrato con i dati cliente in tempo reale sul microsite.',
      LoyaltyCardTitle: 'Saldo punti',
      LoyaltyCardHint: 'Il livello e i punti del cliente appaiono qui.',
      QuickActionSample1: 'Azione rapida 1',
      QuickActionSample2: 'Azione rapida 2',
      QuickActionSample3: 'Azione rapida 3',
      QuickActionSample4: 'Azione rapida 4',
      QuickActionsHeadingCard1: 'Sfrutta al massimo i tuoi punti',
      QuickActionsHeadingCard2: 'Il carnevale dei premi è arrivato!',
      RewardSampleTitle1: 'Tour privato in vigna',
      RewardSampleTitle2: 'Weekend alle terme',
      RewardSampleTitle3: 'Cena per due',
      RewardSampleMerchant: 'Nome del commerciante',
      RewardSampleDistance: '0,3 km',
      CategoryRewardsAllRewards: 'Tutti i premi',
      RewardCta: 'Visualizza',
      ChallengeSampleTitle1: 'Sfida passi settimanale',
      ChallengeSampleTitle2: 'Gira e vinci',
      ChallengeSampleTitle3: 'Check-in giornaliero',
      ChallengeSampleDescription: 'Completala per ottenere punti bonus',
      ActiveStampSampleTitle: 'Titolo della campagna timbri',
      ActiveRaffleSampleTitle: 'Titolo della lotteria',
      ActiveStamps: 'Timbri',
      ActiveStampProgress: '{{current}}/{{total}} timbri',
      ActiveTickets: '{{count}} biglietti',
      ActiveResume: 'Riprendi',
      AllChallenges: 'Tutte le sfide',
      ChallengeEndsInDay: 'Termina tra {{count}} giorno',
      ChallengeEndsInDays: 'Termina tra {{count}} giorni',
      StreakSampleTitle1: 'Accesso',
      StreakSampleTitle2: 'Transazioni',
      StreakSampleTitle3: 'Check-in giornaliero',
      StreakSampleRule1: 'Accedi per 7 giorni consecutivi',
      StreakSampleRule2: '2 accessi al mese per 12 mesi',
      StreakSampleRule3: 'Fai check-in 10 giorni di fila',
      StreakSampleUnit1: 'accessi',
      StreakSampleUnit2: 'transazioni',
      StreakSampleUnit3: 'check-in',
      StreakUnitDays: 'giorni',
      StreakLabel: 'La tua serie',
      StreakWeekProgress: '{{current}} / {{target}} {{unit}} questa settimana',
      StreakRemaining: 'Ancora {{count}} {{unit}} questa settimana per restare in pari',
      StreakOnTrack: 'Sei in pari questa settimana',
      PointRedemptionSampleTitle: 'Punti in cashback',
      PointRedemptionSampleDescription: 'Riscatta i tuoi punti come cashback',
      PointRedemptionValue: '{{points}} punti = {{value}}',
      PointRedemptionValueShort: '{{points}} pt = {{value}}',
      PointRedemptionUnit: 'Punti',
      PointRedemptionAccumulated: 'Punti accumulati',
      PointRedemptionCashback: 'Valore cashback',
      PointRedemptionCta: 'Riscatta ora',
      TransferPointsSampleTitle: 'Trasferisci punti',
      TransferPointsSampleDescription: 'Condividi punti con amici e familiari',
      TransferPointsCta: 'Trasferisci ora',
      Points: '{{points}} pt',
      SeeAll: 'Vedi tutto',
      ShowLess: 'Mostra meno',
      GoToItem: "Vai all'elemento {{index}}",
      Distance: 'A 1,2 km',
      New: 'Nuovo',
      Upcoming: 'In arrivo',
      EndsOn: 'Termina il {{date}}',
      LeaderboardRankLabel: 'La tua posizione in classifica',
      LeaderboardSampleTitle1: 'Gara a punti del mese',
      LeaderboardSampleTitle2: 'Sprint di spesa del weekend',
      LeaderboardSampleTitle3: 'Campioni dei referral',
      LeaderboardSampleRank: 'Posizione {{rank}}°',
      LeaderboardFeaturedRankSuffix: '°',
      LeaderboardSampleRankSuffix: '°'
    }
  },
  [PublishKey]: {
    Load: {
      Failed: 'Impossibile caricare la landing page.',
      Retry: 'Riprova'
    },
    Actions: {
      Label: 'Azioni della landing page',
      SaveDraft: 'Salva',
      Publish: 'Pubblica',
      ChangeStartingPoint: 'Cambia punto di partenza',
      Unsaved: 'Modifiche non salvate',
      DraftSaved: 'Bozza salvata {{date}}',
      Published: 'Pubblicata {{date}}',
      NotPublished: 'Non ancora pubblicata'
    },
    Toasts: {
      DraftSaved: 'Bozza salvata.',
      Published: 'Landing page pubblicata.',
      AlreadyPublished: 'Già pubblicata. Non ci sono modifiche da pubblicare.',
      SaveFailed: 'Impossibile salvare la bozza. Riprova.',
      PublishFailed: 'Impossibile pubblicare la landing page. Riprova.',
      Invalid: 'Correggi i problemi evidenziati e riprova.'
    },
    Issues: {
      Title: 'Correggi questi problemi prima di pubblicare',
      GoToBranding: 'Vai al Branding',
      Section: '{{name}}: {{issue}}',
      UnsupportedAttribute: 'Contiene un’impostazione non supportata.',
      UnknownSection: 'Questa sezione non è più disponibile.',
      DuplicateSection: 'Questa sezione è stata aggiunta più volte.',
      InvalidLayout: 'Il layout selezionato non è valido.',
      LayoutNotAllowed: 'Questa sezione non supporta un layout.',
      UnknownQuickLink: 'Un link rapido selezionato non è più disponibile.',
      DuplicateQuickLink: 'Un link rapido è selezionato più volte.',
      ModuleDisabled: 'Il modulo di questa sezione è disattivato.',
      InvalidTag: 'Il tag selezionato non è valido.',
      TagRequired: 'Seleziona un tag per questa sezione.',
      TagUnavailable: 'Il tag selezionato non è più disponibile. Selezionane un altro.',
      ThemeIncomplete: 'Il tema del modello è incompleto. Usa invece il Branding globale.',
      BrandingInvalid:
        'Il Branding globale contiene valori non validi. Correggili nella scheda Branding.',
      BrandingIncomplete: 'Nel Branding globale mancano valori obbligatori: {{fields}}.',
      Generic: 'Questa configurazione non è valida.'
    }
  },
  [PreviewKey]: {
    Open: 'Anteprima',
    Title: 'Anteprima della landing page',
    Close: 'Chiudi',
    Notice: 'Anteprima delle modifiche in corso. Nulla di quanto mostrato è pubblicato.'
  },
  [ControlKey]: {
    Title: 'Impostazioni di controllo',
    Description:
      'Attiva o disattiva le funzionalità del microsite. Le modifiche si applicano subito.',
    Flags: {
      show_quest: 'Missioni',
      show_nearme: 'Vicino a me',
      rewards_carousel: 'Carosello premi',
      show_point_transfer: 'Trasferimento punti',
      show_popup_campaign: 'Campagne pop-up',
      show_reward_nav_button: 'Pulsante di navigazione premi',
      show_reward_favourite_button: 'Pulsante preferiti premi',
      show_progress_bar_campaigns_on_home_page: 'Campagne con barra di avanzamento in home page',
      show_instant_reward_campaigns_on_home_page: 'Campagne con premio immediato in home page',
      manual_claim_raffle_ticket: 'Riscatto manuale dei biglietti della lotteria'
    },
    Toasts: {
      Saved: 'Impostazioni di controllo salvate',
      SaveFailed: 'Impossibile salvare le impostazioni di controllo. Riprova.'
    },
    Load: {
      Failed: 'Impossibile caricare le impostazioni di controllo.',
      Retry: 'Riprova'
    }
  },
  [GuardKey]: {
    Title: 'Scartare le modifiche non salvate?',
    Content: 'Hai modifiche non salvate. Andranno perse se lasci questa scheda.',
    Discard: 'Scarta modifiche',
    KeepEditing: 'Continua a modificare'
  }
};
